import { Injectable } from '@angular/core';
import { NameValue } from '../model/name-value.model';

export interface IUtilService {
  isNumeric(text: string): boolean;

  isBoolean(text: string): boolean;

  isNullOrUndefined(object: any): boolean;

  isNotNullOrUndefined(object: any): boolean;

  map(sourceObject: any, destinationObject: any): void;

  mapSafe(sourceObject: any, destinationObject: any): void;

  clone(object: any): any;

  /*string */
  isNumeric(text: string): boolean;

  contains(string: string, stringcontains: string): boolean;

  containsAnyCase(string: string, stringcontains: string): boolean;

  startswith(string: string, startswith: string): boolean;

  endswith(string: string, endswith: string): boolean;

  toLowerTrim(str: string): string;

  toTitleCase(str: string): string;

  isNullEmptyOrWhitespace(str: string): boolean;

  isNotNullEmptyOrWhitespace(str: string): boolean;

  right(str: string, length: number): string;

  left(str: string, length: number): string;

  getDynamicText(str: string, replacementCollection: Array<NameValue>): string;

  /*date */
  getShortDateString(dte: Date): string;

  parseJsonDate(json: string): Date;

  convertJsonDateStringsToDates(object: any): void;

  subtractDays(date: Date, days: number): Date;

  addDays(date: Date, days: number): Date;

  /* number */
  isNotNullAndGreaterThanZero(num: number): boolean;

  isNullOrLessThanOrEqualToZero(num: number): boolean;

  /* URL */
  getUrlParts(url: string): any;

  getQueryStringParamValue(paramName: string, expectedType: string, url: string): any;

  /*Collections */
  getObjectInArrayFromPropertyValue(array: any[], propertyname: string, value: any): any;

  /*Email*/
  isValidEmail(email: string): boolean;
  splitEmail(s: string, delimiter: string): [string] | [string,  string];

  /*Cookies*/
  getCookieValue(name: string, expectedtype: string): any;

  setCookieValue(cookiename: string, value: any, expiredays: number, expectedtype: string): void;

  deleteCookie(cookiename: string): void;
}
